
// app
import * as utils from 'utils';

export function DynamicValue({ values, field }) {
  return <div data-testid="dynamic-table-component-total">{getValue(field, values)}</div>;
}

const getValue = (field, values) => {
  if (!field || !field.dynamicValue || typeof values !== 'object') return 0;
  const { variant } = field.dynamicValue;

  if (variant === 'sum') {
    return (
      <>
        {utils.generic.getSumOfArray(values)}
        {field.variant === 'percent' && '%'}
      </>
    );
  }

  return 0;
};

export default DynamicValue;
